export defa mx-1  ult function effectTarget(effectParams, $slideEl) {
  if (effectParams.transformEl) {
    return $slideEl.find(effectParams.transformEl).css({
      'backfa mx-1  ce-visibility': 'hidden',
      '-webkit-backfa mx-1  ce-visibility': 'hidden',
    });
  }
  return $slideEl;
}
